import { Provider as StoreProvider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import store from '@App/app.store';

import SourcesLegend from '../../../SourcesLegend/SourcesLegend.jsx';

import './sources-legend-control.css';

class SourcesLegendControl {
  constructor(onModeChange) {
    this._onModeChange = onModeChange;
  }

  onAdd() {
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl sources-legend-control';
    this._root = createRoot(this._container);
    this._root.render(
      <StoreProvider store={store}>
        <SourcesLegend onModeChange={this._onModeChange} />
      </StoreProvider>,
    );
    return this._container;
  }

  onRemove() {
    this._root?.unmount();
    this._container?.remove();
  }
}

export default SourcesLegendControl;
